import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'sup', 'sub'];
const ALLOWED_ATTRIBUTES: string[] = [];

export function sanitizeRichText(
    dirty: string,
    extraAllowedTags: string[] = [],
    extraAllowedAttributes: string[] = []
): string {
    return DOMPurify.sanitize(dirty, {
        ALLOWED_TAGS: [...ALLOWED_TAGS, ...extraAllowedTags],
        ALLOWED_ATTR: [...ALLOWED_ATTRIBUTES, ...extraAllowedAttributes],
        KEEP_CONTENT: true,

        // we want a string output, not TrustedHTML
        RETURN_TRUSTED_TYPE: false,
    });
}
